import { Link } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/seo";

export function FactFinderSuccessPage() {
  return (
    <>
      <SEO
        title="Form Submitted Successfully"
        description="Your fact finder form has been submitted"
        noIndex
      />

      <div className="min-h-[70vh] flex items-center justify-center px-4">
        <div className="max-w-md text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <FiCheckCircle className="size-10 text-green-600" />
          </div>

          <h1 className="text-3xl font-serif font-medium mb-4">
            Thank You!
          </h1>

          <p className="text-muted-foreground mb-6">
            Your fact finder form has been submitted successfully. Our team will review
            your information and be in touch with you shortly.
          </p>

          <div className="p-4 bg-muted rounded-lg mb-8">
            <h2 className="font-medium mb-2">What happens next?</h2>
            <ul className="text-sm text-muted-foreground text-left space-y-2">
              <li>1. Our team will review your submitted information</li>
              <li>2. We'll research the best loan options for your situation</li>
              <li>3. Your broker will contact you to discuss recommendations</li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild>
              <Link to="/">Return to Home</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/contact">Contact Us</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
